import { IdNome } from "../id-nome.model"

export class TemplateEnvioRedirecionamento{
  templateId!: number
  operadorId?: number
  etapas!: any[]
  fluxo!: IdNome
}
